export function formatDateToDDMMYYYY(dateString, bIncludeTime) {
    const date = new Date(dateString);

    const day = date.getUTCDate().toString().padStart(2, '0');
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const year = date.getUTCFullYear();

    let formattedDate = `${day}/${month}/${year}`;

    if (bIncludeTime) {
        const hour = date.getUTCHours().toString().padStart(2, '0');
        const minute = date.getUTCMinutes().toString().padStart(2, '0');
        const second = date.getUTCSeconds().toString().padStart(2, '0');
        formattedDate += ` ${hour}:${minute}`;
    }

    return formattedDate;
}

export function mergeDateWithTime(dateString, timeString) {
    const [year, month, day] = dateString.split('-');
    const [hours, minutes] = timeString.split(':');

    const date = new Date(Date.UTC(year, month - 1, day, hours, minutes));
    const isoString = date.toISOString();

    return isoString;
}

export const combineDateAndTimeUTC = (date, time) => {
    try {
        const [hours, minutes] = time.split(':');
        const combinedDate = new Date(date);
        combinedDate.setUTCHours(hours, minutes, 0, 0);
        return combinedDate.toISOString();
    }
    catch (ex) {
        return null;
    }
};

export function timeDifference(time1, time2) {
    let [hours1, minutes1] = time1.split(':').map(Number);
    let [hours2, minutes2] = time2.split(':').map(Number);
  
    let totalMinutes1 = hours1 * 60 + minutes1;
    let totalMinutes2 = hours2 * 60 + minutes2;
  
    return Math.abs(totalMinutes1 - totalMinutes2);
  }

export function GetStateOfDay() {
    const d = new Date();
    let hours = d.getHours();
    let minutes = d.getMinutes();

    let hhMM = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;

    if (hhMM >= '00:00' && hhMM < '12:00') {
        return 'Morning';
    } else if (hhMM >= '12:00' && hhMM < '18:00') {
        return 'Afternoon';
    } else {
        return 'Evening';
    }
}



export function extractHHMM(dateString, removeSpace = false) {
    if (dateString) {
        if (dateString.length == 5) return dateString;

        const date = new Date(dateString);

        const hour = date.getUTCHours().toString().padStart(2, '0');
        const minute = date.getUTCMinutes().toString().padStart(2, '0');
        const second = date.getUTCSeconds().toString().padStart(2, '0');
        let formattedDate = `${(!removeSpace ? ' ' : '')}${hour}:${minute}`;

        return formattedDate;
    }
}